import './testimonies.css'
import SubHeading from '../../subHeading/SubHeading'

const Testimonies = () => {
    const testimonies = [
        {
            id: 1,
            text: 'Queridas Diana y Carolina, muchas gracias por crear, sostener, cuidar y parir el 1er EnCuMe y por querer compartirlo con pasión. Creo que la felicidad consiste en gozar de la propia existencia, admirarse con la vida y devolver al mundo lo recibido. Gracias Diana por sentir esa fuerza vital y dejarte guiar por ella. Gracias Carolina por dejarte tocar por una necesidad que se ha convertido en deseo. Gracias a las dos por la acogida, el trabajo y el cariño. ¡Felicidades!',
            author: 'Núria Beitia Hernández',
            date: '5 de junio de 2019'
        },
        {
            id: 2,
            text: 'Creo que es indispensable crear consensos, construir en conjunto, el Encuentro ha sido una muestra de que muchas estamos en sintonía, con proyectos en la misma línea y que juntas podemos tener más fuerza y visibilidad.',
            author: 'Noelia García Toyos',
            date: '19 de junio de 2019'
        }
    ]

    return (
        <section className='testimonies'>
            <div className='testimonies__container'>
                <SubHeading title='Testimonios' color={true} />
                
                <div className='testimonies__grid'>
                    {testimonies.map((testimony) => (
                        <div key={testimony.id} className='testimonies__card'>
                            <div className='testimonies__content'>
                                <p className='testimonies__text'>
                                    "{testimony.text}"
                                </p>
                                <div className='testimonies__author-info'>
                                    <p className='testimonies__author'>
                                        <strong>{testimony.author}</strong>
                                    </p>
                                    <p className='testimonies__date'>{testimony.date}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Testimonies
